import '../scss/styles.scss';
//JS

import "jquery-match-height/jquery.matchHeight";

import {sliders} from './sliders'
import AOS from 'aos';


import "rellax/rellax.min"
import "flickity-imagesloaded"

import Rellax from "rellax";
import {validator} from "./validator";


$(function(){
    new Rellax(".rellax");
    sliders.init();
    validator.init();
    AOS.init({duration: 600});
    //caches a jQuery object containing the header element
    var header = $(".masthead");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 50) {
            header.addClass("fixed");
        } else {
            header.removeClass("fixed");
        }
    });

    jQuery(document).ready(function($){
        console.log('ready');
        $('#choice_2_39_1').on('change', function(e){

            var building_val = $('#input_2_22').val();
            var add_2 = $('#input_2_23').val();
            var town_city = $('#input_2_24').val();
            var postcode = $('#input_2_25').val();
            if($(this).is(":checked")){
                $('#input_2_29').val(building_val);
                $('#input_2_30').val(add_2);
                $('#input_2_31').val(town_city);
                $('#input_2_32').val(postcode);
            }else{
                $('#input_2_29').val('');
                $('#input_2_30').val('');
                $('#input_2_31').val('');
                $('#input_2_32').val('');
            }

        })
    })



})